import React, { useEffect, useState } from "react";
import AddIcon from "../../../assets/svg/AddIcon.svg";
import TrashIcon from "../../../assets/svg/TrashIcon.svg";
import { Modal, Container, Row, Col } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import {
  GET_ALL_ROLES,
  GET_ALL_USER_Roles,
  SYNC_ROLE_TO_USER,
  SYNC_PERMISSION_TO_ROLL,
} from "../../../URLs/Apis"; 
import { Checkbox } from "@mui/material";
import { useSelector } from "react-redux";

function AgentOprator({ agentID }) {
  // const { user } = useSelector((state) => state.auth);

  // const token = "1|uXWWHVAxUbLR94IuQ07nZUT5306vlnjfGFo4AUoR16bcf002";

    const { user } = useSelector((state) => state.auth);
      
      const token = user?.token;

  const headers = {
    Authorization:
      "Bearer " + token
  };

  const [userRoles, setUserRoles] = useState(null);
  const [allRolesToAssign, setAllRolesToAssign] = useState([]);
  const [showAssignRoleModal, setShowAssignRoleModal] = useState(false);
  const [checkedRoleIdsForAssignment, setCheckedRoleIdsForAssignment] = useState([]);

  const [showManagePermissionsModal, setShowManagePermissionsModal] = useState(false);

  const [allPermissions, setAllPermissions] = useState([]);
  const [roleBeingEditedForPermissions, setRoleBeingEditedForPermissions] = useState(null);
  const [checkedPermissionIdsForRole, setCheckedPermissionIdsForRole] = useState([]);


  useEffect(() => {
    if (agentID) {
      fetchUserRoles(agentID);

      fetchAllRolesAndPermissions();
    } else {
     
      setUserRoles([]);
      setAllRolesToAssign([]);
      setAllPermissions([]);
    }
  }, [agentID]); 


  const fetchUserRoles = (userId) => {
    if (!userId) {
      console.warn("Agent ID is missing. Cannot fetch user roles.");
      setUserRoles([]); 
      return;
    }
    setUserRoles(null); 
    axios
      .get(`${GET_ALL_USER_Roles}?user_id=${userId}&user_type=operator`, {
        headers: { Authorization: "Bearer " + token },
      })
      .then((response) => {
        console.log("User Roles with Permissions:", response);
        const roles = Array.isArray(response.data.data?.user?.roles)
          ? response.data.data.user.roles
          : [];
        setUserRoles(
          roles.map((role) => ({
            ...role,
            permissions: Array.isArray(role.permissions)
              ? role.permissions
              : [],
          }))
        );
      })
      .catch((error) => {
        console.error(
          "Failed to load user roles:",
          error?.response?.data || error
        );
        toast.error("Failed to load user roles.");
        setUserRoles([]);
      });
  };

  const fetchAllRolesAndPermissions = () => {
    axios
      .get(GET_ALL_ROLES, {
        headers: { Authorization: "Bearer " + token },
      })
      .then((response) => {
        console.log("All Roles:", response);
        const roles = Array.isArray(response.data.data?.roles)
          ? response.data.data.roles
          : [];
        setAllRolesToAssign(roles);

        const uniquePermissionsMap = new Map();
        roles.forEach((role) => {
          if (Array.isArray(role.permissions)) {
            role.permissions.forEach((permission) => {
              if (permission?.id && permission?.name) {
                uniquePermissionsMap.set(permission.id, {
                  id: permission.id,
                  name: permission.name,
                });
              }
            });
          }
        });
        setAllPermissions(Array.from(uniquePermissionsMap.values()));
      })
      .catch((error) => {
        console.error(
          "Failed to load roles and permissions:",
          error?.response?.data || error
        );
        toast.error("Failed to load roles and permissions list.");
        setAllRolesToAssign([]);
        setAllPermissions([]);
      });
  };

  const openAssignRoleModal = () => {
    if (!agentID) {
       toast.error("Agent ID is missing. Cannot open role assignment.");
       return;
    }
    axios
      .get(`${GET_ALL_USER_Roles}?user_id=${agentID}&user_type=operator`, {
        headers: { Authorization: "Bearer " + token },
      })
      .then((response) => {
        const userRoles = Array.isArray(response.data.data?.user?.roles)
          ? response.data.data.user.roles
          : [];
        const userRoleIds = userRoles
          .map((role) => role.id)
          .filter((id) => id !== null && id !== undefined);
        setCheckedRoleIdsForAssignment(userRoleIds);
        setShowAssignRoleModal(true);
      })
      .catch((error) => {
        console.error(
          "Failed to load user roles for modal:",
          error?.response?.data || error
        );
        toast.error("Failed to load user roles for assignment.");
        setCheckedRoleIdsForAssignment([]);
        setShowAssignRoleModal(true);
      });
  };

  const closeAssignRoleModal = () => {
    setShowAssignRoleModal(false);
    setCheckedRoleIdsForAssignment([]);
  }

  const handleAssignRoleCheckboxChange = (roleId) => {
    setCheckedRoleIdsForAssignment(prevCheckedRoleIds => {
      if (prevCheckedRoleIds.includes(roleId)) {
        return prevCheckedRoleIds.filter((id) => id !== roleId);
      } else {
        return [...prevCheckedRoleIds, roleId];
      }
    });
  };

  const saveRoleAssignment = () => {
    if (!agentID) {
         toast.error("Agent ID is missing. Cannot save roles.");
         return;
     }

    const body = {
      user_id: agentID,
      user_type: "operator",
      role_ids: checkedRoleIdsForAssignment.filter(id => id !== null && id !== undefined), 
    };
    console.log("Saving Roles to User:", body);

    axios
      .post(SYNC_ROLE_TO_USER, body, {
        headers: {Authorization: "Bearer " + token},
      })
      .then((response) => {
        toast.success(response.data.message || "Roles assigned successfully.");
        setShowAssignRoleModal(false);
        fetchUserRoles(agentID);
      })
      .catch((error) => {
        console.error(
          "Failed to assign roles:",
          error?.response?.data || error
        );
        toast.error(
          error?.response?.data?.message ||
            error.message ||
            "Failed to assign roles."
        );
      });
  };

  const removeRoleAssignment = (roleIdToRemove) => {
      if (!agentID) {
          toast.error("Agent ID is missing. Cannot remove role.");
          return;
      }

      if (!Array.isArray(userRoles)) {
          console.warn("User roles not loaded yet or in unexpected format.");
          toast.error("Cannot remove role. User roles not loaded.");
          return;
      }

      const currentAssignedRoleIds = userRoles.map(role => role.id).filter(id => id !== null && id !== undefined);
      const newRoleIds = currentAssignedRoleIds.filter(id => id !== roleIdToRemove);

      const body = {
          user_id: agentID,
          user_type: "operator",
          role_ids: newRoleIds, 
      };
      console.log("Removing Role. Syncing roles:", body);

      axios
          .post(SYNC_ROLE_TO_USER, body, {
              headers,
          })
          .then((response) => {
              toast.success(response.data.message || "Role removed successfully.");
              fetchUserRoles(agentID); 
          })
          .catch((error) => {
              console.error("Failed to remove role:", error?.response?.data || error);
              toast.error(error?.response?.data?.message || error.message || "Failed to remove role.");
          });
  };


  const openManagePermissionsModal = (role) => {
    setRoleBeingEditedForPermissions(role);
    const initialCheckedPermissionIds = Array.isArray(role?.permissions)
        ? role.permissions.map(p => p.id).filter(id => id !== null && id !== undefined)
        : [];
    setCheckedPermissionIdsForRole(initialCheckedPermissionIds);
    setShowManagePermissionsModal(true);
  };

  const closeManagePermissionsModal = () => {
    setShowManagePermissionsModal(false);
    setRoleBeingEditedForPermissions(null); 
    setCheckedPermissionIdsForRole([]); 
  };

  const handleRolePermissionCheckboxChange = (permissionId) => {
    setCheckedPermissionIdsForRole(prevChecked => {
        if (prevChecked.includes(permissionId)) {
          return prevChecked.filter((id) => id !== permissionId);
        } else {
          return [...prevChecked, permissionId];
        }
    });
  };

  const handleSaveRolePermissions = () => {
    if (!roleBeingEditedForPermissions?.id) {
        toast.error("Role information missing. Cannot save permissions.");
        console.error("Role object or ID missing when attempting to save role permissions.");
        return;
    }

    const formData = new FormData();
    formData.append('role', roleBeingEditedForPermissions.id); 

    checkedPermissionIdsForRole.filter(id => id !== null && id !== undefined).forEach(permissionId => {
        formData.append('permissions[]', permissionId);
    });

    console.log("Saving Permissions for Role:", roleBeingEditedForPermissions.name, "with permission IDs:", checkedPermissionIdsForRole);

    axios
        .post(SYNC_PERMISSION_TO_ROLL, formData, { headers })
        .then((response) => {
            toast.success(response.data.message || "Role permissions updated successfully.");
            closeManagePermissionsModal();
            fetchUserRoles(agentID);
        })
        .catch((error) => {
            console.error("Failed to save role permissions:", error?.response?.data || error);
            toast.error(error?.response?.data?.message || error.message || "Failed to update role permissions.");
        });
  };


  const formatName = (name) => {
    if (!name) return "";
    return name
      .split("-")
      .map(
        (word) =>
          word.charAt(0).toUpperCase() +
          word.slice(1).toLowerCase()
      )
      .join(" ");
  };

  const modalBodyStyle = {
      display: "flex",
      flexDirection: "column",
      padding: '0 20px' 
  };


  return (
    <>
      {/* --- Assign Role Modal --- */}
      <Modal show={showAssignRoleModal} onHide={closeAssignRoleModal} centered> 
        <Modal.Header className="AddStaffModal_header" closeButton>
          <Modal.Title className="AddStaffModal_title">
            Assign Roles to User
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={modalBodyStyle}>
          <div className="permissions-list" style={{ flexGrow: 1, overflowY: 'auto', maxHeight: '400px' }}>
            {!agentID ? (
                 <p className="text-center text-danger">Select an Agent to assign roles.</p>
            ) : allRolesToAssign.length === 0 ? (
                 <p className="text-center">No roles available to assign.</p>
            ) : (
              allRolesToAssign.map((role, index) => (
                  <div key={role.id} className="permissionsItem_Authoriztion d-flex align-items-center">
                    <Checkbox
                      className="p-0"
                       sx={{
                            color: 'black',
                            '&.Mui-checked': {
                                color: 'black',
                            },
                        }}
                      checked={checkedRoleIdsForAssignment.includes(role.id)}
                      onChange={() => handleAssignRoleCheckboxChange(role.id)}
                      disabled={role.id === null || role.id === undefined}
                    />
                    <span>{index + 1}. {formatName(role.name)}</span>
                  </div>
              ))
            )}
          </div>

          <div className="foterAddModel mt-3">
            <button type="button" className="closAddModal" onClick={closeAssignRoleModal}>
              Cancel
            </button>
            <button
              type="button"
              className="saveAddModeal"
              onClick={saveRoleAssignment}
              disabled={!agentID} 
            >
              Save
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showManagePermissionsModal}
        onHide={closeManagePermissionsModal}
        centered
        dialogClassName="custom-modal-width modal-dialog-scrollable" 
      >
        <Modal.Header className="AddStaffModal_header" closeButton>
          <Modal.Title className="AddStaffModal_title" style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>
            Manage Permissions for Role: {formatName(roleBeingEditedForPermissions?.name)}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ ...modalBodyStyle, padding: '0 20px' }}>
          <div style={{ flexGrow: 1, maxHeight: '400px', overflowY: 'auto', padding: '10px 0' }}>
            {!agentID ? ( 
                <p className="text-center text-danger">Select an Agent (or ensure roles/permissions are loaded) to manage permissions.</p>
            ) : allPermissions.length === 0 ? (
                <p className="text-center">No permissions available to assign to roles.</p>
            ) : (
              <Container fluid className="p-0">
                <Row>
                  {allPermissions.map((permission, index) => (
                    <Col xs={12} sm={6} md={4} key={permission.id} className="mb-2">
                      <div className="permission-item d-flex align-items-center">
                        <Checkbox
                          className="p-0"
                          sx={{
                            color: 'black',
                            '&.Mui-checked': {
                              color: 'black',
                            },
                          }}
                          checked={checkedPermissionIdsForRole.includes(permission.id)}
                          onChange={() => handleRolePermissionCheckboxChange(permission.id)}
                           disabled={permission.id === null || permission.id === undefined}
                        />
                        <span>{index + 1}. {formatName(permission.name)}</span>
                      </div>
                    </Col>
                  ))}
                </Row>
              </Container>
            )}
          </div>
        </Modal.Body>

        {/* Sticky Footer */}
        <div
          className="foterAddModel d-flex justify-content-center gap-2"
          style={{
            padding: '12px 20px',
            borderTop: '1px solid #dee2e6',
            background: '#fff',
          }}
        >
          <button
            type="button"
            className="closAddModal"
            style={{
              padding: '4px 10px',
              fontSize: '0.85rem',
              width: '100px',
            }}
            onClick={closeManagePermissionsModal}
          >
            Cancel
          </button>
          {/* Button to save permissions for the ROLE */}
          <button
            type="button"
            className="saveAddModeal"
            style={{
              padding: '4px 10px',
              fontSize: '0.85rem',
              width: '100px',
            }}
            onClick={handleSaveRolePermissions}
            disabled={!roleBeingEditedForPermissions?.id} 
          >
            Save
          </button>
        </div>

      </Modal>


      {/* --- Main Content Section --- */}
      <div className="col-md-12">
        <div className="card py-3 px-2 my-3 mr-5 mianStyelToAgentOprator width-98">
          <div className="sm:p-1 border-B">
            <div className="container d-flex align-items-center">
              <div className="container d-flex justify-content-end align-items-center">
                <div className="edeteTheAgentOprator_prmition">
                  {/* Button to open Assign Role modal */}
                  <button
                    onClick={openAssignRoleModal}
                    type="button"
                    className="bottomofPremissionOprator"
                    style={{ height: "48px", padding: "10px" }}
                    disabled={!agentID} 
                  >
                    <img
                      src={AddIcon}
                      alt="Add Role" 
                      style={{ marginRight: '5px', verticalAlign: 'middle' }} 
                    />
                    Add Role
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* List of Assigned Roles */}
          <div className="RolesList_Authoriztion">
            {/* Handle loading state */}
            {userRoles === null ? (
                 <p className="permissionsOfRoll_RolesItem_Authoriztion text-center">Loading User Roles...</p>
            ) : !agentID ? (
                 <p className="permissionsOfRoll_RolesItem_Authoriztion text-center text-danger">Select an Agent to view roles.</p>
            ) : userRoles.length === 0 ? (
                 <p className="permissionsOfRoll_RolesItem_Authoriztion text-center">
                   No Roles Assigned to User
                 </p>
            ) : (
              userRoles.map((role) => (
                  <div key={role.id} className="RolesItem_Authoriztion d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                      {/* Role Name */}
                      <div className="title_RolesItem_Authoriztion me-2">
                        {formatName(role.name)}
                      </div>
                   
                      {role.id !== null && role.id !== undefined && (
                          <button
                              className="btn btn-link p-0"
                              onClick={() => removeRoleAssignment(role.id)}
                              title={`Remove ${formatName(role.name)} Role`}
                              style={{ border: 'none', background: 'none', cursor: 'pointer' }}
                          >
                              <img src={TrashIcon} alt="Remove Role" style={{ width: '16px', height: '16px', verticalAlign: 'middle' }} />
                          </button>
                      )}
                    </div>

                     {role.id !== null && role.id !== undefined && (
                        <div className="EdatShow_RolesItem_Authoriztion">
                          <div
                            onClick={() => openManagePermissionsModal(role)}
                            className="border_RolesItem_Authoriztion w-100"
                            style={{ cursor: 'pointer', textAlign: 'center' }} 
                          >
                            <span className="numP_RolesItem_Authoriztion">
                              {Array.isArray(role.permissions) ? role.permissions.length : 0}
                            </span>
                            <span className="text_RolesItem_Authoriztion">
                              Edit Role Permissions
                            </span> {/* Updated text */}
                          </div>
                        </div>
                     )}
                  </div>
              ))
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default AgentOprator;